import {strTrimLeft as trimLeft} from '@/utils/string'

export const strTrimLeft = (value, chars, isRegexp = true) => {
	return trimLeft(value, chars, isRegexp)
}